import { onBeforeMount } from "vue";
import { makeLogger } from "@/shared/consola";
import store from "@/store";

const logger = makeLogger("useAsyncVuexModules");

export const useAsyncVuexModules = (...modules) => {
    const registered = [];
    onBeforeMount(() => {
        for (const [moduleName, module] of modules) {
            if (store.hasModule(moduleName)) {
                continue;
            }
            store.registerModule(moduleName, module);
            registered.push(moduleName);
        }
        if (registered.length) {
            logger.trace(`Registered dynamic vuex modules: [ ${registered.join(" | ")} ]`);
        }
    });
};
